export const API_URL = "https://back.smart-lmz.uz";
